/**
 * @module normalizeContentList
 */
const { mediaUrlFromType } = require('./mediaTypeUtils');
const { rectifyMediaCollectionType } = require('./rectifyMediaCollectionType');
const { getUrlStructureByPath } = require('./urls');

/**
 * Convenience worker function to iterate over the specified data array and convert to a normalized data object.
 *
 * @param {object} params - The function params object.
 * @param {object} params.data - The media data.
 * @param {string} params.template - The template name.
 * @param {object} params.type - The object containing the media type data.
 *
 * @returns {object | null} The normalized object, with null value returned in the case data does not have nodes.
 */
function normalizeContentList({ data, template, type }) {
  if (data && data.length) {
    const normalized = {
      '@nodes': [],
    };
    data.forEach((item) => {
      const {
        collection,
        item: itemSlug,
        subCollection,
      } = getUrlStructureByPath(item['@path']);
      let collectionType =
        item && item['@path'] && item['@path'].split('/').length > 1
          ? item['@path'].split('/')[1]
          : '';
      collectionType = rectifyMediaCollectionType(collectionType);
      let imgType = 'albumImage_public';
      if (
        type &&
        type.field &&
        type.itemsType &&
        type.field === 'carousel' &&
        type.itemsType === 'general-carousel'
      ) {
        imgType = 'cinemaImage_public';
      }
      let image = item.featuredImage_public;
      if (!image) {
        image =
          item.channelImageList && item.channelImageList[imgType]
            ? item.channelImageList[imgType]
            : '';
      }

      normalized['@nodes'].push(item['@id']);
      normalized[item['@id']] = {
        '@id': item['@id'],
        '@name': item['@name'],
        '@nodes': [],
        '@nodeType': item['@nodeType'],
        '@path': item['@path'],
        '@workspace': item['@workspace'],
        collectionType,
        content: item.description,
        image,
        linkTitle: 'Read more',
        'mgnl:created': item['mgnl:created'],
        'mgnl:lastModified': item['mgnl:lastModified'],
        'mgnl:template': template,
        partNumber: item.part,
        subTitle: item.description,
        target: '_self',
        title: item.title,
        url: mediaUrlFromType({
          slug: itemSlug,
          subCollection,
          type: collection,
        }),
      };
    });
    return normalized;
  }
  return null;
}

module.exports = {
  normalizeContentList,
};
